import { createSlice } from '@reduxjs/toolkit';
import { get, post } from 'api/fetch';
import { updateAppInfo } from 'state/app';

// ================== Reducers ================== //

const slice = createSlice({
  name: 'global/Profile',
  initialState: {
    nest: {
      isLoading: false,
      error: null,
      nest: {
        eggs: [],
        hasCompletedNPSSurveyNI: false,
        hasCompletedNPSSurveyRD: false,
        hasCompletedNPSSurveyRH: false
      }
    },
    avatar: {
      isLoading: false,
      error: null
    }
  },
  reducers: {
    // fetchNest
    fetchNestRequest: (state) => {
      state.nest.isLoading = true;
      state.nest.error = null;
    },
    fetchNestSuccess: (state, { payload }) => {
      state.nest.isLoading = false;
      state.nest.error = null;
      state.nest.nest = payload;
    },
    fetchNestFailure: (state, { payload }) => {
      state.nest.isLoading = false;
      state.nest.error = payload;
      state.nest.nest = [];
    },
    // setAvatar
    setAvatarRequest: (state) => {
      state.avatar.isLoading = true;
      state.avatar.error = null;
    },
    setAvatarSuccess: (state) => {
      state.avatar.isLoading = false;
      state.avatar.error = null;
    },
    setAvatarFailure: (state, { payload }) => {
      state.avatar.isLoading = false;
      state.avatar.error = payload;
    }
  }
});

export default slice.reducer;

// ================== Actions ================== //

const { actions } = slice;

export const fetchNest = () => async (dispatch) => {
  dispatch(actions.fetchNestRequest());

  try {
    const nest = await get('/insurance/ni/plan-holders/nest');
    dispatch(actions.fetchNestSuccess(nest));
  } catch (error) {
    dispatch(actions.fetchNestFailure(error));
  }
};

export const setAvatar = (avatar) => async (dispatch) => {
  dispatch(actions.setAvatarRequest());

  try {
    await post('/users/avatar', avatar);
    dispatch(actions.setAvatarSuccess());
    dispatch(updateAppInfo({ user: { avatar } }));
  } catch (error) {
    dispatch(actions.setAvatarFailure(error));
  }
};
